import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import NextImage from 'components/NextImage';

import { partners } from '../../helpers';

import styles from './styles.module.scss';

const Banner = ({ appLink }) => (
	<Container className={styles.block} innerClassName={styles.container}>
		<NextImage
			className={styles.wrapper}
			src="/images/pushkinsCard/banner.webp"
			objectFit="contain"
			objectPosition="center bottom"
			layout="fill"
			priority
			quality={100}
			animate={false}
		/>
		<div className={styles.content}>
			<h1 className={styles.title}>Пушкинская карта</h1>
			<div className={styles.subtitle}>
				Программа популяризации культурных мероприятий среди&nbsp;молодежи
			</div>
			<div className={styles.tel}>
				телефон горячей линии <a href="tel:+78001000645">8-800-100-06-45</a>
			</div>
			<div className={styles.link}>{appLink}</div>
			<div className={styles.partners}>
				{partners.map(({ url, svg, title }) => (
					<a
						key={url}
						href={url}
						target="_blank"
						rel="noopener"
						className={styles.partnerLink}
						aria-label={title}
					>
						{svg}
					</a>
				))}
			</div>
		</div>
	</Container>
);

Banner.propTypes = {
	appLink: PropTypes.node.isRequired
};

export default Banner;
